import { createResource } from 'react-resource-router';
export const createPaginatedResource = ({
  getData,
  getKey,
  ...arg
}) => {
  return createResource({
    ...arg,
    getKey: (routerContext, customContext) => {
      const {
        query
      } = routerContext;
      const page = query['page'] || '1';
      const key = `${getKey(routerContext, customContext)}#${page}`;
      return key;
    },
    getData: (routerContext, customContext) => {
      const {
        query
      } = routerContext;
      const page = parseInt(query['page']) || 1;
      return getData(routerContext, customContext)({
        page
      });
    }
  });
};